import React, { useEffect, useState } from 'react';
import { FaFileUpload, FaImage } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import DOMPurify from 'dompurify';
import he from 'he';
import JoditEditor from 'jodit-react';

function AddResourse() {
    const location = useLocation();
    const navigate = useNavigate();

    const [resourse, setResourse] = useState({
        file: null,
        description: '',
        type: location?.state?.type
    });
    const [bt, setBt] = useState(false);
    const [id, setId] = useState("");
    const [mediaBorder, setMediaBorder] = useState(false);
    const [docBorder, setDocBorder] = useState(false);
    const [filePreview, setFilePreview] = useState(null);
    const [fileType, setFileType] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [thumbnail, setThumbnail] = useState(null);
    const [thumbnailPreview, setThumbnailPreview] = useState(null);
    console.log(location, "Location")

    useEffect(() => {
        setResourse((prev) => ({
            ...prev,
            description: location?.state?.description ? he.decode(location.state.description) : "",
        }));
        setId(location?.state?._id);

        if (location?.state?.screen === "edit") {
            const mediaUrl = location?.state?.media;
            const mediaExtensions = /\.(jpg|jpeg|png|gif|mp4|mov|avi|wmv|flv|svg)$/i;
            const documentExtensions = /\.(pdf|xls|xlsx|doc|docx)$/i;

            if (mediaUrl) {
                setFilePreview(mediaUrl);
                if (mediaExtensions.test(mediaUrl)) {
                    setMediaBorder(true);
                    setDocBorder(false);
                    setFileType("media");

                    // If video and thumbnail exists, set preview
                    if (location?.state?.media?.match(/\.(mp4|mov|avi|wmv|flv|webm|mkv|m4v)$/i) && location?.state?.thumbnail) {
                        setThumbnailPreview(location?.state?.thumbnail);
                    }
                } else if (documentExtensions.test(mediaUrl)) {
                    setMediaBorder(false);
                    setDocBorder(true);
                    setFileType("document");
                } else {
                    setMediaBorder(false);
                    setDocBorder(false);
                    setFileType("");
                }
            }
        }
    }, [location]);

    const isHtmlContentEmpty = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html || "";
        return div.textContent.trim() === "";
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const fileURL = URL.createObjectURL(file);
            const type = file.type;

            setResourse((prev) => ({
                ...prev,
                file,
            }));

            if (type.startsWith("image/") || type.startsWith("video/")) {
                setMediaBorder(true);
                setDocBorder(false);
                setFileType("media");
            } else if (
                type === "application/pdf" ||
                type === "application/msword" ||
                type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
                type === "application/vnd.ms-excel" ||
                type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) {
                setMediaBorder(false);
                setDocBorder(true);
                setFileType("document");
            } else {
                setMediaBorder(false);
                setDocBorder(false);
                setFileType("");
            }

            setFilePreview(fileURL);
            setThumbnail(null);
            setThumbnailPreview(null);
        }
    };

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
            setThumbnail(file);
            setThumbnailPreview(URL.createObjectURL(file));
        } else {
            toast.error("Please upload a valid image file as thumbnail.");
        }
    };

    const handleAdd = async () => {
        const sanitizedDescription = DOMPurify.sanitize(resourse?.description);
        if (!sanitizedDescription || isHtmlContentEmpty(sanitizedDescription)) {
            return toast.error("Description is required");
        }

        if (!resourse?.file) return toast.error("Please upload either a file or an image/video");

        const file = resourse.file;
        const fileType = file.type;
        const allowedVideoTypes = ["video/mp4", "video/quicktime", "video/x-msvideo", "video/x-ms-wmv", "video/x-flv", "video/webm", "video/x-matroska", "video/x-m4v"];

        if (fileType.startsWith("video/")) {
            const allowedVideoTypes = [
                "video/mp4",
                "video/quicktime",
                "video/x-msvideo",
                "video/x-ms-wmv",
                "video/x-flv",
                "video/webm",
                "video/x-matroska",
                "video/x-m4v"
            ];

            if (!allowedVideoTypes.includes(fileType)) {
                return toast.error("Unsupported video format. Allowed formats: mp4, mov, avi, wmv, flv, webm, mkv, m4v");
            }

            if (!thumbnail) {
                return toast.error("Please upload a thumbnail image for the video.");
            }
        }
        setBt(true);
        const data = new FormData();
        data.append("file", file);
        data.append("type", location?.state?.type);
        data.append("description", sanitizedDescription);
        if (fileType.startsWith("video/") && thumbnail) {
            data.append("thumbnail", thumbnail);
        }

        try {
            const response = await handleApiCall("post", endpoint.AddResourse, data);
            if (response?.data?.code === 200) {
                toast.success(response?.data?.message);
                setTimeout(() => navigate(-1), 1000);
            } else {
                toast.error(response?.response?.data?.errorMessage || "Failed to add resource");
            }
        } catch (error) {
            console.error("Error adding resource:", error);
            toast.error("Something went wrong!");
        } finally {
            setBt(false);
        }
    };

    const handleEdit = async () => {
        const sanitizedDescription = DOMPurify.sanitize(resourse?.description);
        if (!sanitizedDescription || isHtmlContentEmpty(sanitizedDescription)) {
            return toast.error("Description is required");
        }
        if (!resourse?.file) return toast.error("Please upload either a file or an image/video");

        const file = resourse.file;
        const fileType = file.type;
        const allowedVideoTypes = ["video/mp4", "video/quicktime", "video/x-msvideo", "video/x-ms-wmv", "video/x-flv", "video/webm", "video/x-matroska", "video/x-m4v"];

        if (fileType.startsWith("video/")) {
            const allowedVideoTypes = [
                "video/mp4",
                "video/quicktime",
                "video/x-msvideo",
                "video/x-ms-wmv",
                "video/x-flv",
                "video/webm",
                "video/x-matroska",
                "video/x-m4v"
            ];

            if (!allowedVideoTypes.includes(fileType)) {
                return toast.error("Unsupported video format. Allowed formats: mp4, mov, avi, wmv, flv, webm, mkv, m4v");
            }

            if (!thumbnail) {
                return toast.error("Please upload a thumbnail image for the video.");
            }
        }


        setBt(true);
        const data = new FormData();
        if (resourse?.file) {
            data.append("file", resourse?.file);
            if (resourse?.file?.type?.startsWith("video/") && thumbnail) {
                data.append("thumbnail", thumbnail);
            }
        }
        data.append("id", location?.state?._id);
        data.append("description", sanitizedDescription);

        try {
            const response = await handleApiCall("put", endpoint.EditResourse, data);
            if (response?.data?.code === 200) {
                toast.success(response?.data?.message);
                setTimeout(() => navigate("/resource-management"), 1000);
            } else {
                toast.error(response?.response?.data?.errorMessage || "Failed to update resource");
            }
        } catch (error) {
            console.error("Error editing resource:", error);
            toast.error("Something went wrong!");
        } finally {
            setBt(false);
        }
    };

    const [docLoading, setDocLoading] = useState(false);

    useEffect(() => {
        if (filePreview?.match(/\.(doc|docx)$/i)) {
            setDocLoading(true);
        } else {
            setDocLoading(false);
        }
    }, [filePreview]);

    return (
        <>
            <div className='p-4'>
                <div className='flex flex-col w-full'>
                    <div className="flex sm:flex-row items-center justify-between">
                        <div
                            className={`h-32 rounded-md border-dashed ${mediaBorder ? "border-pink-500" : "border-gray-400"} border-2 flex flex-col items-center justify-center text-center p-2`}
                            style={{ height: "8rem", width: "45%" }}
                        >
                            <FaImage className="text-gray-500 text-3xl mb-2" />
                            <label className="text-gray-600 cursor-pointer">
                                + Upload Image/Video
                                <input type="file" accept="image/*,video/*" className="hidden" onChange={handleFileChange} />
                            </label>
                        </div>
                        <span className="sm:mx-2 sm:my-0 my-2 text-gray-400 text-lg">or</span>
                        <div
                            className={`h-32 rounded-md border-dashed ${docBorder ? "border-blue-500" : "border-gray-400"} border-2 flex flex-col items-center justify-center text-center p-2`}
                            style={{ height: "8rem", width: "45%" }}
                        >
                            <FaFileUpload className="text-gray-500 text-3xl mb-2" />
                            <label className="text-gray-600 cursor-pointer">
                                + Upload File
                                <input
                                    type="file"
                                    accept=".pdf,.xls,.xlsx,.doc,.docx,.ppt,.pptx"
                                    className="hidden"
                                    onChange={handleFileChange}
                                />

                            </label>
                        </div>
                    </div>



                    {filePreview && (
                        <div className="mt-4 p-2 border border-gray-300 rounded-md">
                            <h3 className="text-lg font-semibold">File Preview:</h3>
                            {fileType === "media" ? (
                                resourse.file?.type?.startsWith("video/") || filePreview.match(/\.(mp4|mov|avi|wmv|flv|webm|mkv|m4v)$/i) ? (
                                    <video controls src={filePreview} className="mt-2 w-64 h-40 object-cover rounded-md" />
                                ) : (
                                    <img src={filePreview} alt="Preview" className="mt-2 w-48 h-32 object-cover rounded-md" />
                                )
                            ) : fileType === "document" ? (
                                <button onClick={() => setShowModal(true)} className="mt-2 text-blue-500 underline">
                                    View Document
                                </button>
                            ) : null}
                        </div>
                    )}
                    {/* Thumbnail Upload Box – Only visible if media is video */}
                    {fileType === "media" &&
                        (resourse.file?.type?.startsWith("video/") || filePreview?.match(/\.(mp4|mov|avi|wmv|flv|webm|mkv|m4v)$/i)) && (
                            <div className="mt-4">
                                <div className="flex sm:flex-row items-center justify-between">
                                    <div
                                        className={` rounded-md border-dashed ${thumbnailPreview ? "border-green-500" : "border-gray-400"} border-2 flex items-center justify-center w-80 text-center p-2 overflow-hidden`}
                                        style={{ position: "relative" }}
                                        onClick={() => document.getElementById("thumbnailInput")?.click()}
                                    >
                                        <input
                                            type="file"
                                            accept="image/*"
                                            id="thumbnailInput"
                                            className="hidden"
                                            onChange={handleThumbnailChange}
                                        />
                                        {thumbnailPreview ? (
                                            <img
                                                src={thumbnailPreview}
                                                alt="Thumbnail"
                                                className="w-full h-full object-cover cursor-pointer"
                                            />
                                        ) : (
                                            <label
                                                htmlFor="thumbnailInput"
                                                className="flex  items-center justify-center text-gray-600 cursor-pointer w-full h-36"
                                            >
                                                <FaImage className="text-gray-500 text-3xl mb-2 flex" />
                                                + Upload Thumbnail (Image) <span className=' text-red-500'>*</span>
                                            </label>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}




                    <div className='flex items-center justify-center rounded-md p-2 mt-7'>
                        <JoditEditor
                            className='w-full h-full bg-transparent outline-none resize-none p-2 text-gray-700'
                            value={resourse.description}
                            config={{
                                placeholder: resourse.description ? '' : 'Description',
                                toolbarAdaptive: false,
                                toolbarSticky: false,
                            }}
                            onBlur={(newContent) => {
                                setResourse((prev) => ({
                                    ...prev,
                                    description: newContent?.trimStart()
                                }));
                            }}
                        />
                    </div>

                    <div className='flex gap-3 mt-4 justify-center sm:justify-start'>
                        <div
                            className='text-black font-bold inline-flex cursor-pointer justify-center px-4 ms-2 items-center hover:bg-[#F6F6F6] border-black rounded-md border-[1px] py-2'
                            onClick={() =>
                                navigate("/resource-management", {
                                    state: { activeTab: location.state?.activeTab || "Coach" },
                                })
                            }
                        >
                            Cancel
                        </div>

                        <button
                            disabled={bt}
                            onClick={location?.state?.screen === "edit" ? handleEdit : handleAdd}
                            className={`px-5 font-bold inline-flex cursor-pointer justify-center ms-2 items-center py-2 rounded-md border-[1px] ${bt
                                ? 'bg-gray-400 text-gray-700 cursor-not-allowed'
                                : 'bg-[#994263] text-white hover:bg-[#e6e0e2] hover:text-black border-[#994263]'}`}
                        >
                            {bt ? (location?.state?.screen === "edit" ? "Updating..." : "Adding...") : (location?.state?.screen === "edit" ? "Update" : "Add")}
                        </button>
                    </div>
                </div>
            </div>

            {/* Document Modal Preview */}
            {showModal && (
                <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 h-screen overflow-hidden">
                    <div className="bg-white rounded-lg shadow-lg w-full h-full overflow-hidden flex flex-col">
                        <div className="flex justify-between items-center px-4 py-2 border-b bg-gray-100">
                            <h2 className="text-lg font-semibold text-gray-800">File Preview</h2>
                            <button
                                className="text-white bg-red-600 hover:bg-red-700 px-3 py-1 rounded-md"
                                onClick={() => setShowModal(false)}
                            >
                                Close
                            </button>
                        </div>

                        <div className="flex-1 relative overflow-hidden">
                            {docLoading && (
                                <div className="absolute top-0 left-0 right-0 z-10 flex items-start justify-start bg-white bg-opacity-80 py-4">
                                    <p className="text-gray-700 text-lg font-medium">
                                        Converting .doc/.docx to PDF for preview...
                                    </p>
                                </div>
                            )}
                            {filePreview?.match(/\.(pdf)$/i) ? (
                                <iframe src={filePreview} title="PDF Preview" className="w-full h-full" frameBorder="0" />
                            ) : filePreview?.match(/\.(doc|docx)$/i) ? (
                                <>
                                    <iframe
                                        src={`https://docs.google.com/gview?url=${encodeURIComponent(filePreview)}&embedded=true`}
                                        title="Doc/Docx Preview"
                                        className="w-full h-full"
                                        frameBorder="0"
                                        onLoad={() => setDocLoading(false)}
                                    />
                                    <div className="bg-white p-4 text-center">
                                        <p className="mt-2 text-gray-500">If the preview doesn’t load, you can download the file below:</p>
                                        <a href={filePreview} download className="inline-block mt-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md">
                                            Download File
                                        </a>
                                    </div>
                                </>
                            ) : filePreview?.match(/\.(xls|xlsx)$/i) ? (
                                <div className="p-4 text-center">
                                    <p className="text-gray-700 mb-4">Excel file preview not supported. Please download the file.</p>
                                    <a href={filePreview} download className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md">
                                        Download File
                                    </a>
                                </div>
                            ) : filePreview?.match(/\.(mp4|mov|avi|webm|mkv)$/i) ? (
                                <video controls src={filePreview} className="w-full h-full object-contain" />
                            ) : filePreview?.match(/\.(jpg|jpeg|png|gif|svg)$/i) ? (
                                <img src={filePreview} alt="Preview" className="w-full h-full object-contain" />
                            ) : (
                                <div className="p-4 text-center">
                                    <p className="text-gray-700 mb-4">No file preview available.</p>
                                    <a href={filePreview} download className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md">
                                        Download File
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <Toastify />
        </>
    );
}

export default AddResourse;
